import { makeStub } from "./_base";
export const CompanyUser = makeStub("CompanyUser");
